module.exports = __webpack_public_path__ + "img/symbol_10_x5.ecd42442.png";